// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__t_MLp","title":"Images45_title__wpCW0","images":"Images45_images__1dLR_"};